exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-dialog{min-height:calc(100% - 160px);margin:80px 160px;display:flex;align-items:center;justify-content:center}@media (max-width:992px){.popup-dialog{margin:0 auto}.popup-content{width:90%!important}}.popup-content{background:#fff;padding:20px;border-radius:20px;position:relative}.popup-backdrop{z-index:1040;background-color:#000;opacity:.1}.popup,.popup-backdrop{position:fixed;top:0;right:0;bottom:0;left:0}.popup{z-index:99999;outline:0;overflow-x:hidden;overflow-y:auto}.modal-close{position:absolute;right:20px;top:20px;cursor:pointer;z-index:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40261b92","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/frontend/components/Modal.vue
// module id = en85
// module chunks = 0